import React from "react";
export default function SVGBarrel() {
  return (
    <svg viewBox="0 0 488.162 488.162">
      <g fill="#000000">
        <path
          fill="#000000"
          d="M440.443,91.682c0-26.385-21.468-47.853-47.853-47.853h-35.205h-109.24V24.386
     c0-13.469-9.039-24.386-20.2-24.386h-86.082c-11.152,0-20.2,10.917-20.2,24.386v19.452H95.572
     c-26.385,0-47.853,21.468-47.853,47.853c0,19.265,11.445,35.904,27.889,43.488v31.555c-16.444,7.584-27.889,24.223-27.889,43.488
     s11.445,35.904,27.889,43.488v31.555c-16.444,7.576-27.889,24.223-27.889,43.488s11.445,35.904,27.889,43.488v24.581
     c-16.444,7.584-27.889,24.223-27.889,43.488c0,26.385,21.468,47.853,47.853,47.853H392.59c26.385,0,47.853-21.468,47.853-47.853
     c0-19.265-11.445-35.904-27.889-43.488V372.24c16.444-7.584,27.889-24.223,27.889-43.488s-11.445-35.904-27.889-43.488v-31.555
     c16.444-7.584,27.889-24.223,27.889-43.488s-11.445-35.904-27.889-43.488V135.17C428.998,127.594,440.443,110.955,440.443,91.682z
      M392.59,225.552h-12.551v87.845h12.551c8.47,0,15.339,6.869,15.339,15.339s-6.869,15.339-15.339,15.339h-12.551v80.879h12.551
     c8.47,0,15.339,6.869,15.339,15.339s-6.869,15.339-15.339,15.339H95.572c-8.47,0-15.339-6.869-15.339-15.339
     s6.869-15.339,15.339-15.339h12.551v-80.879H95.572c-8.47,0-15.339-6.869-15.339-15.339s6.869-15.339,15.339-15.339h12.551v-87.845
     H95.572c-8.47,0-15.339-6.869-15.339-15.339s6.869-15.339,15.339-15.339h12.551v-87.846H95.572c-8.47,0-15.339-6.869-15.339-15.339
     s6.869-15.339,15.339-15.339h26.093h9.112h117.368h109.232h35.205c8.47,0,15.339,6.869,15.339,15.339s-6.869,15.339-15.339,15.339
     h-12.551v87.846h12.551c8.47,0,15.339,6.869,15.339,15.339S401.06,225.552,392.59,225.552z"
        />
        <path
          fill="#000000"
          d="M244.081,120.815c0,0-8.665,12.339-20.598,31.88c-45.78,74.937-139.836,256.066,20.598,256.066
     c185.015,0,31.588-240.882,4.064-281.98C245.576,122.953,244.081,120.815,244.081,120.815z M255.038,357.47
     c21.76-10.047,25.231-30.572,19.891-52.316c-4.519-18.419,23.833-26.231,28.361-7.82c8.25,33.595,0.35,69.946-33.408,85.529
     C252.786,390.749,237.838,365.412,255.038,357.47z"
        />
      </g>
    </svg>
  );
}
